export default __webpack_public_path__ + "static/media/database-blue.60b01556.svg";